// Standard Library Imports
import React, { useEffect, useState, useContext } from 'react';

// External Library imports
import _ from 'lodash';
import { toast } from 'react-toastify';

// Internal Module Imports
import TabsComponent from '../../../../components/Tabs/Tabs';
import { useQueryParamWithDefault, useLoader } from '../../../../hooks';
import { NumberParam, StringParam } from 'use-query-params';
import Savings from './Savings/Savings';
import { AdminService } from '../../../../services/BiddingService/CommonServices/AdminService';
import { CustomerService } from '../../../../services/BiddingService/CommonServices/CustomerService';
import { ROOT_USER_ROLES, ADMIN_USER_ROLES } from '../../../../constants';
import { AuthContext } from '../../../../context/AuthContext';
import FixedChargers from './FixedChargers';

const DEFAULT_DROPDOWN_OPTION = {
    label: 'All',
    value: 'all',
};

const getDropdownOption = (data = []) => {
    const temp = [
        {
            label: 'All',
            value: 'all',
        },
    ];
    data.map((el) => {
        temp.push({ label: el.name, value: el._id });
    });
    return temp;
};

const SmartCharge = ({ cId }) => {
    const [selectedIndex, setSelectedIndex] = useQueryParamWithDefault('subTab', NumberParam, 0, cId);
    const [startLoader, stopLoader] = useLoader();
    const { state } = useContext(AuthContext);
    const userRole = _.get(state, ['user', 'userRole']);
    const isRootUser = ROOT_USER_ROLES.includes(userRole);
    const adminId = _.get(state, ['user', 'adminId']);
    const isAdminUser = ADMIN_USER_ROLES.includes(userRole);
    const [admins, setAdmins] = useState([DEFAULT_DROPDOWN_OPTION]);
    const [selectedAdmin, setSelectedAdmin] = useQueryParamWithDefault('admin', StringParam, isAdminUser ? adminId : DEFAULT_DROPDOWN_OPTION.value, cId, { clearOnUnmount: false });
    const [customers, setCustomers] = useState([DEFAULT_DROPDOWN_OPTION]);
    const [selectedCustomer, setSelectedCustomer] = useQueryParamWithDefault('customer', StringParam, DEFAULT_DROPDOWN_OPTION.value, cId, { clearOnUnmount: false });

    useEffect(() => {
        if (isRootUser) getAdmins();
    }, []);

    useEffect(() => {
        if (selectedAdmin && selectedAdmin !== 'all') getCustomers();
    }, [selectedAdmin]);

    const getAdmins = () => {
        AdminService.GetAdmins(startLoader, handleGetAdminSuccess, handleError, stopLoader);
    };

    const handleGetAdminSuccess = ({ data }) => {
        const options = getDropdownOption(data.data);
        setAdmins(options);
    };

    const getCustomers = () => {
        const params = { adminId: selectedAdmin };
        CustomerService.GetCustomers(params, startLoader, handleGetCustomerSuccess, handleError, stopLoader);
    };

    const handleGetCustomerSuccess = ({ data }) => {
        const options = getDropdownOption(data.data);
        setCustomers(options);
    };

    const handleError = (err) => {
        toast.error(err?.response?.data?.message);
    };

    const tabs = [
        {
            name: 'Fixed Chargers',
            component: (
                <FixedChargers
                    cId={cId}
                    admins={admins}
                    customers={customers}
                    selectedAdmin={selectedAdmin}
                    setSelectedAdmin={setSelectedAdmin}
                    selectedCustomer={selectedCustomer}
                    setSelectedCustomer={setSelectedCustomer}
                />
            ),
            tabId: 1,
        },
        {
            name: 'Savings',
            component: (
                <Savings
                    cId={cId}
                    admins={admins}
                    customers={customers}
                    selectedAdmin={selectedAdmin}
                    setSelectedAdmin={setSelectedAdmin}
                    selectedCustomer={selectedCustomer}
                    setSelectedCustomer={setSelectedCustomer}
                />
            ),
            tabId: 2,
        },
    ];

    return (
        <div className={'ventilation'}>
            <TabsComponent
                tabs={tabs}
                selectedIndex={selectedIndex}
                onChangeTab={(index) => {
                    setSelectedIndex(index);
                }}
                cId={cId}
            />
        </div>
    );
};

export default SmartCharge;
